import axios from "axios"

const endpoint = "/api/credit-cards" // Passe dies an deinen Router-Pfad an

function getHeaders() {
  return { headers: { Authorization: localStorage.getItem("token") } }
}

export default {
  creditCardBills: {
    update(id, data) {
      // data ist hier ein normales JS Objekt, kein FormData, da wir das Bild meist nicht ändern beim Editieren
      return axios.put(`${endpoint}/${id}`, data, getHeaders()).then((res) => res.data)
    },
    delete(id) {
      return axios.delete(`${endpoint}/${id}`, getHeaders()).then((res) => res.data)
    },
    fetchAll(params) {
      // params: { search, studioId, uploaderId, dateFrom, dateTo, minAmount, maxAmount ... }
      // Convert params object to query string via axios params serializer or just pass object
      return axios
        .get(endpoint, {
          params: params,
          ...getHeaders(),
        })
        .then((res) => res.data)
    },

    // NEW: Analyze Receipt
    analyze(formData) {
      return axios.post(`${endpoint}/analyze`, formData, getHeaders()).then((res) => res.data)
    },

    upload(formData) {
      return axios.post(`${endpoint}/upload`, formData, getHeaders()).then((res) => res.data)
    },

    getFileUrl(id) {
      // Gibt die URL zurück, die das Frontend für <img> Tags nutzen kann
      // (Achtung: Token muss ggf. als Query Param übergeben werden oder via axios fetchBlob gehandhabt werden,
      // da <img> keine Header sendet.
      // Lösung hier: Wir laden das Bild per JS und setzen Blob URL)
      return `${endpoint}/file/${id}`
    },

    // Helper um Blob für Image-Preview zu laden (da Auth Header nötig)
    async fetchImageBlob(id) {
      const response = await axios.get(`${endpoint}/file/${id}`, {
        ...getHeaders(),
        responseType: "blob",
      })
      return URL.createObjectURL(response.data)
    },

    downloadPdf(month, year) {
      const url = `${endpoint}/export/pdf?month=${month}&year=${year}`
      return axios.get(url, { ...getHeaders(), responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" })
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = `CC_Auszug_${month}_${year}.pdf`
        link.click()
      })
    },
  },
}
